package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun EmptyDashboardReportItem(
    windowSizeMode: WindowSizeModeEnum,
    title: String?,
)
{

    Column(
        modifier = Modifier
            .cursor(Cursor.Pointer)
            .margin(
                right = if (windowSizeMode== WindowSizeModeEnum.PHONE) 0.px
                else Dimen.extraLargePadding,
                bottom = Dimen.mediumPadding,
                top = Dimen.mediumPadding,
            )
            .width(
                when(windowSizeMode){
                    WindowSizeModeEnum.Desktop->Dimen.dashboardReportItemWidth
                    WindowSizeModeEnum.TABLET->Dimen.dashboardReportItemTabletPhoneWidth
                    WindowSizeModeEnum.PHONE->Dimen.dashboardReportItemTabletPhoneWidth
                }
            )
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.PHONE,
                Modifier
                    .fillMaxWidth()
                    .height(Dimen.dashboardReportItemMobileHeight)
            )
            .thenIf(
                windowSizeMode!= WindowSizeModeEnum.PHONE,
                Modifier
                    .height(Dimen.dashboardReportItemHeight)
            )
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb,
            ),
    )
    {
        TopHeader(
            name=title?:"",
        )


        Column(
            modifier = Modifier
                .padding(Dimen.largePadding)
                .fillMaxSize(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        )
        {
            VectorIcon(
                color = Theme.TextDisabled.hex,
                height = Dimen.extraLargeIconSize,
                width = Dimen.extraLargeIconSize,
                pathData = Res.PathIcon.emptyTableIcon,
            )
            SpanText(
                text = Strings.current().noData,
                modifier = Modifier
                    .margin(top = Dimen.normalPadding)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.Medium)
                    .fontSize(FontSizes.semiExtraLargeFontSize)
                    .color(Theme.TextPrimary.rgb)
            )
        }








    }


}





@Composable
private fun TopHeader(
    name: String,
)
{
    Column(
        modifier =Modifier
            .backgroundColor(Theme.ActionHover.rgb)
            .fillMaxWidth()
            .overflow(Overflow.Hidden)
            .padding(
                leftRight = Dimen.largePadding,
            )
            .height(Dimen.dashboardReportItemHeaderHeight),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start,
    )
    {
        SpanText(
            text=name,
            modifier = Modifier
                .fillMaxWidth()
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.largeFontSize)
                .color(Theme.TextSecondary.rgb)
                .fontWeight(FontWeight.SemiBold)
                .overflowText()
        )

    }
}
